import React from "react";
import BasePaginatedDropdown from "./BasePaginatedDropdown";
import { type DropdownWithoutOptionsProps } from "../models";
import SubLabel from "components/Atoms/Sublabel";
import { useClientId } from "common/SessionContext";

type Props = DropdownWithoutOptionsProps<server.dto.BookkeepingSmall> & {
  selectIfOnlyOption?: boolean
};

const BookkeepingPaginatedDropdown = (props: Props) => {
  const clientId = useClientId();
  const fetchBookkeepings = async (search: string, page: number) => {
    const res = await window.CoreApi.Bookkeeping.PaginatedSmall({
      clientId,
      page,
      perPage: 500,
      visible: "onlyYes",
      keyword: search,
    }, "limitByUserAccess")
    return res;
  };

  React.useEffect(() => {
    if (props.selectIfOnlyOption && !props.value) {
      fetchBookkeepings("", 1)
        .then(res => {
          if (res.data.data.length === 1) {
            props.onChange(res.data.data[0]);
          }
        });
    }
  }, []);

  const isSelected = (bookkeepingId: number) => {
    if (props.value == null) return false;

    if (Array.isArray(props.value)) {
      return props.value.some(v => v.bookkeepingId === bookkeepingId);
    }

    return (props.value as server.dto.Bookkeeping).bookkeepingId === bookkeepingId;
  };

  return <BasePaginatedDropdown
    excludeKeys={props.excludeKeys}

    fetchOptions={fetchBookkeepings}
    getLabel={bookkeeping => bookkeeping.name}
    getValue={bookkeeping => bookkeeping.bookkeepingId}
    renderOption={(bookkeeping) => <div>
      <div>{bookkeeping.name}</div>
      {!isSelected(bookkeeping.bookkeepingId) && <SubLabel small>{bookkeeping.code}</SubLabel>}
      {isSelected(bookkeeping.bookkeepingId) && <div className="s1_small">{bookkeeping.code}</div>}
    </div>}
    config={{
      ...props.config,
      isSearchable: true
    }}
    value={props.value}
    onChange={props.onChange}
  />;
};

export default BookkeepingPaginatedDropdown;